export default {
  $validator: (value) => {
    return typeof value === "string";
  },
};
